/* template */
<template><div class="package-item"><div class="package-item-desc"><div class="package-item-desc-skechy"><div class="package-item-desc-skechy-num">{{ packageInfo.amount }}</div><div class="package-item-desc-skechy-unit">个</div></div><div class="package-item-desc-detail"><div class="package-item-desc-detail-top">{{ packageInfo.name }}</div><div class="package-item-desc-detail-bot">{{ packageInfo.remark }}</div></div></div><mpx-view @tap="share" class="package-item-btn-wrapper"><div :class="(!isStock && 'share')" class="package-item-btn" v-if="(!isHarmonyos)">{{ btnText }}</div></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m47719440"}'>
  .package-item
    height 82px
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    background #FFF7E6
    border-radius 10px
    border 0.75px solid rgba(255, 89, 0, 0.19)
    margin-bottom 10px
    &-desc
      display flex
      &-skechy
        width 90px
        display flex
        justify-content center
        align-items baseline
        letter-spacing 0px
        color #F86316
        &-num
          font-family Barlow Semi Condensed
          font-size 35px
          font-weight 400
          line-height 35px
        &-unit
          font-size 14px
          font-weight 600
          line-height 15px
          font-family PingFangSC-Semibold
      &-detail
        display flex
        flex-direction column
        letter-spacing 0px
        &-top
          font-size 15px
          line-height 15px
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 8px
        &-bot
          font-family PingFangSC-Regular
          font-weight 400
          font-size 10px
          line-height 10px
          color #B69786
    .package-item-btn-wrapper
      width 94px
      display flex
      justify-content center
      align-items center
      .package-item-btn
        display flex
        justify-content center
        align-items center
        font-family PingFangSC-Medium
        font-weight 500
        color rgba(248, 99, 22, 0.3)
        &.share
          padding 8px 12px
          border-radius 13.5px
          background linear-gradient(270deg, #FF4A4E 0%, #FF712E 100%)
          font-size 13px
          font-family PingFangSC-Medium
          font-weight 500
          line-height 11px
          letter-spacing 0px
          color #FFFFFF
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m47719440"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./package-item.mpx.js?isComponent&outputPath=components%2Fpackage-item47719440%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./package-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpackage-item47719440%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m47719440"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/package-item47719440/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
